import React, { useMemo } from "react";
import { ThemeProvider, useTheme } from "@material-ui/core/styles";
import { createCrmTheme } from "../pages/CrmRelationship/theme";

export default function KanbanTheme({ children }) {
  const outerTheme = useTheme();
  const theme = useMemo(() => {
    const base = createCrmTheme(outerTheme);
    const dark = base.palette.type === "dark";
    const foreground = dark ? "#FFFFFF" : base.crm.text;
    return {
      ...base,
      kanbanPage: true,
      kanbanDark: dark,
      palette: { ...base.palette, text: { ...base.palette.text, primary: foreground }, action: { ...base.palette.action, active: foreground } },
      overrides: {
        ...base.overrides,
        MuiIconButton: { root: { ...base.overrides.MuiIconButton.root, color: foreground } },
        MuiInputLabel: { root: { color: foreground } },
        MuiSelect: { icon: { color: foreground } },
        MuiMenuItem: { root: { ...base.overrides.MuiMenuItem.root, "&$selected, &$selected:hover": { backgroundColor: base.crm.selected } } },
        MuiPaper: { ...base.overrides.MuiPaper, root: { ...base.overrides.MuiPaper.root, color: foreground } },
      },
    };
  }, [outerTheme]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
